export default function (func, text = 'are you sure ?') {
  return async (...args) => {
    const isConfirm = window.confirm(text);

    if (isConfirm) {
      await func(...args);
    }
  };
}
